import api from '@/apis/di/salaryScaleAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';
// Combo grid Ngạch lương
export const useSalaryScaleComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { extendFilter } = usefilterActionCombo();
  const { proxy } = getCurrentInstance();
  // func call api lấy dữ liệu combo
  const onSalaryScaleComboboxLoadData = (payload, row, column) => {
    payload.sort = 'salary_scale_name';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    payload.columns += ',salary_scale_code';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const salaryScaleComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã ngạch lương',
        dataField: 'salary_scale_code',
        width: 150,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên ngạch lương',
        dataField: 'salary_scale_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 450,
      },
    ],
    displayField: 'salary_scale_name',
    valueField: 'salary_scale_name',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onSalaryScaleComboboxLoadData,
  };

  return {
    salaryScaleComboConfig,
    onSalaryScaleComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
